import photo from '../assets/demo/profile_compressed.webp';
import showPhoto from '../assets/shows/optimized/show.webp';
import showPhotoOne from '../assets/shows/optimized/show_1.webp';
import showPhotoThree from '../assets/shows/optimized/1000007338.webp';
import showPhotoFour from '../assets/shows/optimized/6c9a80d8202526e8a38af8b39eaa1512.webp';
import showPhotoFive from '../assets/shows/optimized/MB402754.webp';
import showPhotoSix from '../assets/shows/optimized/VideoCapture_20250913-160430.webp';
import showVeragioPhoto from '../assets/shows/optimized/show-veragio.webp';
import showHellWeekPhoto from '../assets/shows/optimized/hell-s-week-2026.webp';
import showMalossiDaysPhoto from '../assets/shows/optimized/malossi-days-2026.webp';
import showPozuolo2026Photo from '../assets/shows/optimized/pozuolo-2026.webp';
import showTerramo2026Photo from '../assets/shows/optimized/terramo-2026.webp';
import showVergato2026Photo from '../assets/shows/optimized/vergato-2026.webp';
import cliffBackground from '../assets/tricks/optimized/cliff-background.webp';
import cliffTwoPhoto from '../assets/tricks/optimized/cliff-2.webp';
import cordovaPhoto from '../assets/tricks/optimized/cordova.webp';
import indyPhoto from '../assets/tricks/optimized/indy.webp';
import shaolinNewPhoto from '../assets/tricks/optimized/shaolin-2026.webp';
import supermanBackground from '../assets/tricks/optimized/superman-background.webp';
// eslint-disable-next-line no-unused-vars
import trickPhotoOne from '../assets/tricks/optimized/IMG_20221024_105624vf.webp';
import doubleGrabPhoto from '../assets/tricks/optimized/double-grab.webp';
import flinstonePhoto from '../assets/tricks/optimized/flinstone.webp';
import heelklickerPhoto from '../assets/tricks/optimized/heelclicker-2.webp';
import supermanSitgrabPhoto from '../assets/tricks/optimized/superman-sitgrab.webp';
import supermanWhitePhoto from '../assets/tricks/optimized/superman-white.webp';

export const profile = {
  firstName: 'Action',
  lastName: 'Fifi',
  role: 'FMX Rider',
  intro: 'Polish FMX athlete, thrill seeker and digital nomad.',
  photo,
  email: 'actionfifi@gmail.com',
  phone: '+48 605 305 522',
  address: 'Gdańsk Poland',
  socials: {
    instagram: 'https://www.instagram.com/actionfifi/?next=',
    youtube: 'https://www.youtube.com/@actionfifi',
    tiktok: 'https://www.tiktok.com/@actionfifi?_r=1&_t=ZN-96Iec2jGI10',
    facebook: 'https://www.facebook.com/',
    whatsapp: 'https://wa.me/48605305522',
    telegram: 'https://t.me/actionfifi',
  },
};

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Bookings', href: '#bookings' },
  { label: 'About', href: '#about' },
  { label: 'Tricks', href: '#tricks' },
  { label: 'Shows', href: '#shows' },
  { label: 'Videos', href: '#videos' },
  { label: 'Contact', href: '#contact' },
];

export const stats = [
  { value: 15, label: 'Years of riding' },
  { value: 7, label: 'Years of FMX' },
  { value: 7, label: 'Moto competitions' },
  { value: 23, label: 'FMX show days' },
  { value: 7, label: 'Countries' },
  { value: 38000, label: 'KM traveled', separator: '\u202F' },
];

export const services = [
  {
    number: '01',
    title: 'FMX Show Organization',
    description:
      'Full mobile FMX setup for events, including airbag setup, ramp delivery, on-site preparation, and show-ready logistics, up to 5 riders, European countries and wordwide.',
  },
  {
    number: '02',
    title: 'FMX Rider Appearance',
    description:
      'Rider for an already organized show, contest, demo, or media event.',
  },
];

export const experience = [
  { years: '03.07.2019', role: 'Motocross race', company: 'Gdańsk, Poland' },
  { years: '14.07.2020', role: 'Motocross race', company: 'Borkowo, Poland' },
  { years: '18.02.2023', role: 'FMX Show - Photoshoot', company: 'LLeida, Spain', targetShowId: 'lleida-2023' },
  { years: '01.07.2023', role: 'FMX Competition', company: 'Särkisalo, Finland', targetShowId: 'sarkisalo-2023-one' },
  { years: '29.06.2024', role: 'FMX Competition - 2nd place best run', company: 'Särkisalo, Finland', targetTrickId: 'superman-white' },
  { years: '13/14.06.2025', role: 'FMX Show', company: 'Imola, Italy', targetShowId: 'imola-2025' },
  { years: '05.07.2025', role: 'FMX Competition - best trick', company: 'Särkisalo, Finland', targetShowId: 'sarkisalo-2025' },
  { years: '30.08.2025', role: 'FMX Show', company: 'Sorø, Denmark' },
  { years: '06.09.2025', role: 'FMX Show', company: 'Pozzuolo, Italy', targetVideoId: 'pozuolo-2025-video' },
  { years: '13/14.09.2025', role: 'FMX Show', company: 'Modena, Italy', targetShowId: 'modena-2025' },
  { years: '10/11.07.2026', role: 'FMX Show', company: 'Jēkabpils, Latvia', targetVideoId: 'jekabpils-2026' },
  { years: '14-16.08.2026', role: "FMX Show - Hell's Week", company: 'Frejus, France', targetShowId: 'hell-s-week-2026' },
  { years: '05.09.2026', role: 'FMX Show', company: 'Pozzuolo, Italy', targetShowId: 'pozuolo-2026' },
  { years: '08/09.09.2026', role: 'FMX Show', company: 'Terramo, Italy', targetShowId: 'terramo-2026' },
  { years: '11/12.09.2026', role: 'FMX Show', company: 'Vergato, Italy', targetShowId: 'vergato-2026' },
  { years: '18/19.09.2026', role: 'FMX Show', company: 'Bergamo, Italy', targetTrickId: 'superman-sitgrab' },
  { years: '20.09.2026', role: 'FMX Show - Malossi Days', company: 'Parma, Italy', targetShowId: 'malossi-days-2026' },
];

export const tricks = [
  { name: 'Superman', targetTrickId: 'superman-white' },
  { name: 'Cliffhanger', targetTrickId: 'cliffhanger' },
  { name: 'Shaolin', targetTrickId: 'shaolin-2026' },
  { name: 'No Foot Can' },
  { name: 'Nac Nac' },
  { name: 'Cordova', targetTrickId: 'cordova' },
  { name: 'Stripper' },
  { name: 'Heelklicker', targetTrickId: 'heelklicker' },
  { name: 'Superman Seat Grab', targetTrickId: 'superman-sitgrab' },
  { name: 'Double Grab', targetTrickId: 'double-grab' },
  { name: 'Superman Indy', targetTrickId: 'superman-indy' },
  { name: 'Flinstone', targetTrickId: 'flinstone' },
  { name: 'Whip' },
];

export const aboutFacts = [
  { label: 'Name', value: 'Action Fifi' },
  { label: 'Phone', value: profile.phone },
  { label: 'Experience', value: '15+ Years riding' },
  { label: 'Nationality', value: 'Polish' },
  { label: 'Email', value: profile.email },
  { label: 'Freelance', value: 'Available' },
  { label: 'Languages', value: 'Polish, English' },
  { label: 'Location', value: 'On the road' },
];

export const trickItems = [
  {
    id: 'cliffhanger',
    type: 'image',
    title: 'Cliffhanger',
    label: 'Photo',
    image: cliffBackground,
    mobileImageMode: 'contain',
  },
  {
    id: 'cliff-2',
    type: 'image',
    title: 'Cliffhanger',
    label: 'Photo',
    image: cliffTwoPhoto,
    mobileImageMode: 'contain',
  },
  {
    id: 'superman',
    type: 'image',
    title: 'Superman',
    label: 'Photo',
    image: supermanBackground,
  },
  {
    id: 'superman-white',
    type: 'image',
    title: 'Superman',
    label: 'Photo',
    image: supermanWhitePhoto,
    mobileImageMode: 'contain',
  },
  {
    id: 'superman-sitgrab',
    type: 'image',
    title: 'Superman Seat Grab',
    label: 'Photo',
    image: supermanSitgrabPhoto,
    mobileImageMode: 'contain',
  },
  {
    id: 'superman-indy',
    type: 'image',
    title: 'Superman Indy',
    label: 'Photo',
    image: indyPhoto,
  },
  {
    id: 'shaolin-2026',
    type: 'image',
    title: 'Shaolin',
    label: 'Photo',
    image: shaolinNewPhoto,
    mobileImageMode: 'contain',
  },
  {
    id: 'cordova',
    type: 'image',
    title: 'Cordova',
    label: 'Photo',
    image: cordovaPhoto,
  },
  {
    id: 'heelklicker',
    type: 'image',
    title: 'Heelklicker',
    label: 'Photo',
    image: heelklickerPhoto,
    mobileImageMode: 'contain',
  },
  // {
  //   type: 'image',
  //   title: 'Superman',
  //   label: 'Photo',
  //   image: trickPhotoOne,
  // },
  {
    id: 'double-grab',
    type: 'image',
    title: 'Double Grab',
    label: 'Photo',
    image: doubleGrabPhoto,
    mobileImageMode: 'contain',
  },
  {
    id: 'flinstone',
    type: 'image',
    title: 'Flinstone',
    label: 'Photo',
    image: flinstonePhoto,
    mobileImageMode: 'contain',
  },
];

export const showItems = [
  {
    id: 'sarkisalo-2025',
    type: 'image',
    title: 'FMX Competition - Särkisalo, Finland 2025',
    label: 'Photo',
    image: showPhoto,
    mobileImageMode: 'shift-left',
  },
  {
    id: 'sarkisalo-2023-one',
    type: 'image',
    title: 'FMX Competition - Särkisalo, Finland 2023',
    label: 'Photo',
    image: showPhotoOne,
  },
  {
    id: 'lleida-2023',
    type: 'image',
    title: 'FMX Show Photoshoot - LLeida, Spain 2023',
    label: 'Photo',
    image: showPhotoFour,
  },
  {
    id: 'imola-2025',
    type: 'image',
    title: 'FMX Show - Imola, Italy 2025',
    label: 'Photo',
    image: showPhotoFive,
  },
  {
    id: 'modena-2025',
    type: 'image',
    title: 'FMX Show - Modena, Italy 2025',
    label: 'Photo',
    image: showPhotoSix,
    mobileImageMode: 'crop-y',
  },
  {
    id: 'veragio-2026',
    type: 'image',
    title: 'FMX Show - Vergato, Italy 2026',
    label: 'Photo',
    image: showVeragioPhoto,
    mobileImageMode: 'contain',
  },
  {
    id: 'hell-s-week-2026',
    type: 'image',
    title: "FMX Show Hell's Week - Frejus, France 2026",
    label: 'Photo',
    image: showHellWeekPhoto,
    mobileImageMode: 'focus-right',
  },
  {
    id: 'pozuolo-2026',
    type: 'image',
    title: 'FMX Show - Pozzuolo, Italy 2026',
    label: 'Photo',
    image: showPozuolo2026Photo,
  },
  {
    id: 'terramo-2026',
    type: 'image',
    title: 'FMX Show - Terramo, Italy 2026',
    label: 'Photo',
    image: showTerramo2026Photo,
    mobileImageMode: 'contain',
  },
  {
    id: 'vergato-2026',
    type: 'image',
    title: 'FMX Show - Vergato, Italy 2026',
    label: 'Photo',
    image: showVergato2026Photo,
    mobileImageMode: 'contain',
  },
  {
    id: 'malossi-days-2026',
    type: 'image',
    title: 'FMX Show Malossi Days - Parma, Italy 2026',
    label: 'Photo',
    image: showMalossiDaysPhoto,
    mobileImageMode: 'contain',
  },
  {
    id: 'sarkisalo-2023-three',
    type: 'image',
    title: 'FMX Competition - Särkisalo, Finland 2023',
    label: 'Photo',
    image: showPhotoThree,
  },
];

// Add future YouTube, Instagram, or uploaded video embeds here.
export const videoItems = [
  {
    id: 'jekabpils-2026',
    type: 'embed',
    title: 'FMX Show - Jēkabpils, Latvia 2026',
    label: 'Video',
    embedUrl: 'https://www.youtube.com/embed/LD87HCR0HGc',
    sourceUrl: 'https://youtube.com/shorts/LD87HCR0HGc?feature=share',
  },
  {
    type: 'embed',
    title: 'YouTube Short 02',
    label: 'Video',
    embedUrl: 'https://www.youtube.com/embed/4RL5C8aTrXg',
    sourceUrl: 'https://youtube.com/shorts/4RL5C8aTrXg?si=oZxthwt3Q2dvT9w7',
  },
  {
    id: 'pozuolo-2025-video',
    type: 'embed',
    title: 'Italian Village With The Best Energy - Pozzuolo, Italy 2025',
    label: 'Video',
    embedUrl: 'https://www.youtube.com/embed/4eP_eN3SXTI',
    sourceUrl: 'https://www.youtube.com/shorts/4eP_eN3SXTI',
  },
  {
    type: 'embed',
    title: 'YouTube Short 04',
    label: 'Video',
    embedUrl: 'https://www.youtube.com/embed/1SKPy6XgDJI',
    sourceUrl: 'https://www.youtube.com/shorts/1SKPy6XgDJI',
  },
  {
    type: 'embed',
    title: 'YouTube Short 05',
    label: 'Video',
    embedUrl: 'https://www.youtube.com/embed/x0G9jtn95ao',
    sourceUrl: 'https://youtube.com/shorts/x0G9jtn95ao?si=WBl4gQxkPl1c53V_',
  },
];
